import * as components from './components'

export default [
  {
    path: '/',
    component: components.Dashboard,
    name: 'dashboard'
  }
]
